module.exports = __webpack_public_path__ + "images/fd4b831c5ee8387b3a3bc88595ac5c08.jpg";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/dog.jpg
// module id = 359
// module chunks = 0